module.exports = __webpack_public_path__ + "672f8bf91b5f7f3d0133f5f9dea5a318.jpg";